export default "__VITE_ASSET__BSg3S8Us__"